import api from "./api";
import endpoints from "./endpoints";

export default {
  login: async function (username: string, password: string) {
    try {
      const token = await api.post(
        endpoints.authentication.login,
        {
          username,
          password
        },
        {}
      );

      const user = await api.get(endpoints.user.profile.get, {
        headers: { Authorization: "Bearer " + token.data }
      });

      if (!user.data.isWebClientLicensed) throw { licenseError: true, data: {} };

      const settings = await api.get(endpoints.user.settings.get, {
        headers: { Authorization: "Bearer " + token.data }
      });

      const tokenData = token.data;
      const userData = user.data;
      const settingsData = settings.data;
      return { token: tokenData, user: userData, settings: settingsData };
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  loginWithToken: async function (token: string) {
    const user = await api.get(endpoints.user.profile.get, {
      headers: { Authorization: "Bearer " + token }
    });

    if (!user.data.isWebClientLicensed) throw { licenseError: true, data: {} };

    const settings = await api.get(endpoints.user.settings.get, {
      headers: { Authorization: "Bearer " + token }
    });

    const userData = user.data;
    const settingsData = settings.data;
    return { token, user: userData, settings: settingsData };
  },
  loginWithCode: async function (provider: string, code: string) {
    try {
      let token = await api.post(endpoints.authentication.loginWithCode, { provider, code });
      let user = await api.get(endpoints.user.profile.get, { headers: { Authorization: "Bearer " + token.data } });

      if (!user.data.isWebClientLicensed) throw { licenseError: true, data: {} };

      let settings = await api.get(endpoints.user.settings.get, { headers: { Authorization: "Bearer " + token.data } });

      token = token.data;
      user = user.data;
      settings = settings.data;
      return { token, user, settings };
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  logout: async function () {
    return await api.post(endpoints.authentication.logout, {});
  },
  getJwt: async function () {
    const response = await api.get(endpoints.authentication.generateJwt, {
      params: {}
    });
    return response.data;
  }
};
